import React from 'react'
import styled from 'styled-components'
import AddNew from 'components/form/add-new'
import AssetItem from 'components/form/assets/asset-item'
import NumDisplay from 'components/num-display'
import { moneyFormat } from 'utils/helpers'

const LayoutGrid = styled.div`
  display: grid;
  grid-template-columns: 10fr minmax(0, 2fr);
  grid-gap: 60px;
  @media (max-width: 767px) {
    display: block;
  }
`

const ItemGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(${props => props.cols ? props.cols : 2}, 1fr);
  grid-gap: 30px;
  @media (max-width: 767px) {
    display: block;
  }
`

export default ({ sectionId, id, data }) => {  
  const colTotals = Object.values(data).reduce((prev, curr) => {
    Object.entries(curr).forEach(item => {
      const [col, num] = item
      if (col === 'self' || col === 'spouse' || col === 'joint')
        prev[col] += num
    })  
    return prev
  }, {self: 0, spouse: 0, joint: 0})

  return (
    <LayoutGrid>
      <fieldset>
        <legend><h2>{id}</h2></legend>
        <ItemGrid>
          { Object.entries(data).map(d => {
            const [k, v] = d
            return (
              <div key={k}>
                <AssetItem sectionId={sectionId} id={k} fields={v} />
              </div>
            )
          }) }
          <AddNew sectionId={sectionId} />
        </ItemGrid>
      </fieldset>
      <div>
        <h3>Section Totals</h3>
        {Object.entries(colTotals).map(total => (
          <NumDisplay
            bigNum={moneyFormat.to(total[1])}
            heading={total[0]}
            key={total[0]}
          />
        ))}
        <hr/>
        <NumDisplay
          bigNum={moneyFormat.to(colTotals.self + colTotals.spouse + colTotals.joint)}
          heading="Total"
        />
      </div>
    </LayoutGrid>
  )
}